<template>
  <section id="datesselector" :class="$conf.sidebar.enabled ? '' : 'on-edge'">
    <button
      :disabled="this.$store.getters['isUiDisabled']"
      class="button"
      type="button"
      @click="(e) => prevDate(e)">
      <b-icon id="downloadicon" icon="arrow-left-bold"></b-icon>
    </button>

    <b-datepicker
      style="display:inline"
      placeholder="-"
      position="is-top-right"
      icon="calendar-today"
      v-model="selectedCalendarDate"
      locale="en-US"
      :nearby-month-days="false"
      :disabled="this.$store.getters['isUiDisabled']"
      :first-day-of-week="1"
      :date-formatter="displayFormat"
      :unselectable-dates="unselectableDates"
      :events="acquisitionEvents">
      <b-dropdown v-model="selectedCalendarTimes" aria-role="list" multiple style="width:auto">
        <button
          class="button is-dark has-background-black-bis"
          type="button"
          slot="trigger">
          <span>{{ $t("selectTime") }}</span>
          <b-icon icon="menu-down"></b-icon>
        </button>
        <b-dropdown-item
          v-for="(item, key) in storeTimes"
          :value="item"
          :key="key"
          aria-role="listitem">
          {{ item.split("T")[1].split(".")[0] }}
        </b-dropdown-item>
      </b-dropdown>
      <!--<b-button icon-left="select-compare" @click="addCurrentLayerToCompare()">{{ $t('addLayerToComparison') }}</b-button>-->
    </b-datepicker>

    <button
      :disabled="this.$store.getters['isUiDisabled']"
      class="button"
      type="button"
      @click="(e) => nextDate(e)">
      <b-icon id="downloadicon" icon="arrow-right-bold"></b-icon>
    </button>
  </section>
</template>

<script>

import log from 'util/log'
import moment from 'moment'

export default {
  data () {
    return {
      acquisitionEvents: [],
      activeCalendarDates: [],
      storeTimes: this.$store.getters['mapTime']
    }
  },
  components: {

  },
  computed: {
    selectedCalendarDate: {
      get () {
        let mapDateIndex = this.$store.getters['mapDateIndex']
        let mapDates = this.$store.getters['mapDates']
        if (mapDates.length !== 0) {
          return new Date(mapDates[mapDateIndex][0])
        }
      },
      set (newDate) {
        const timezoneOffset = newDate.getTimezoneOffset()
        let newDate0 = new Date(newDate.getTime() - (timezoneOffset*60*1000))
        newDate0 = newDate0.toISOString()
        const mapDatesList = this.$store.getters['mapDatesList']
        this.$store.dispatch('setMapDateIndex', mapDatesList.indexOf(newDate0))
        this.$store.dispatch('updatePublicWmsRequest')
      }
    },
    selectedCalendarTimes: {
      get () {
        return this.$store.getters['mapTime']
      },
      set (value) {
        this.$store.dispatch('setMapTime', value)
      }
    }
  },
  mounted () {
      this.$store.watch(
        () => this.$store.getters['mapDates'],
        dates => {
          if (dates) {
            let calendarDates = []
            let activeDates = []
            
            dates.forEach(mapDateObject => {
              mapDateObject[1].forEach(date => {
                let ob = {date:new Date(mapDateObject[0]), type:'is-danger'}
                calendarDates.push(ob)
              })
              activeDates.push(mapDateObject[0])
            })

            this.acquisitionEvents = calendarDates
            this.activeCalendarDates = activeDates
          }
        }
      )
      this.$store.watch(
        () => this.$store.getters['mapDateIndex'],
        index => {
          if (this.$store.getters['mapDates'].length !== 0) {
            this.storeTimes = this.$store.getters['mapDates'][index][1]
          } else {
            this.storeTimes = []
          }
        }
      )
  },
  methods: {
    displayFormat (date) {
      const offset = date.getTimezoneOffset()
      let newDate = new Date(date.getTime() - (offset*60*1000))
      return newDate.toISOString().split('T')[0]
    },
    unselectableDates (day) {
      day = moment(day).startOf('day').utcOffset(0, true).toISOString()
      return !this.activeCalendarDates.includes(day)
    },
    // Previous map date.
    prevDate (e) {
      var mapDateIndex = this.$store.getters['mapDateIndex']
      this.$store.dispatch('setMapDateIndex', mapDateIndex - 1)
      this.$store.dispatch('updatePublicWmsRequest')
    },
    // Next map date.
    nextDate (e) {
      var mapDateIndex = this.$store.getters['mapDateIndex']
      this.$store.dispatch('setMapDateIndex', mapDateIndex + 1)
      this.$store.dispatch('updatePublicWmsRequest')
    },
    addCurrentLayerToCompare () {
      this.$store.dispatch('addLayerToCompare')
    }
  }
}

</script>

<style lang="stylus">

section#datesselector
  position: fixed
  white-space: nowrap
  left: 10px
  transition: 0.35s
  z-index: 1004
  bottom: 1%
  >.cld
    width: 120px
    text-align-last: center
  >.vd-picker
    background: #000000
    >.vd-picker__body
      background: #000000
      >.vd-picker__table
        background: #000000

@media (min-width: 768px)
  section#datesselector
    position: absolute
    left: 355px
    width: auto
    top: unset
    &.on-edge
      left: 360px

@media (max-width: 767px)
  section#datesselector
    left: unset
    right: 10px
    bottom: 100px
    position: relative
    float: right
    >.vd-picker
      background: #000000
      >.vd-picker__body
        background: #000000
        >.vd-picker__table
          background: #000000

</style>
